// extracted by mini-css-extract-plugin
export default {"page":"Subpage_page__3+b0U","topBar":"Subpage_topBar__HZo8F","backIcon":"Subpage_backIcon__-FyHR","topBarTitle":"Subpage_topBarTitle__ht8Jc","panel":"Subpage_panel__rcqwt"};